/**
 * place-prefab - loads prefab JSON definitions and instantiates them. Retrieves prefab
 * data from storage, constructs actors, applies transform overrides, and returns spawned actors.
 */
import { instantiatePrefabAsync } from '../utils/serialization/prefab.js';

import type { ActorMiscInfo, Transform } from './common.js';
import type { Actor } from '../actors/Actor.js';
import type { World } from '../game/World.js';


export interface PrefabArgs {
  path: string;
  transform?: Transform;
  miscInfo?: ActorMiscInfo; // Optional metadata for the actor
}

async function spawnPrefab(prefab: PrefabArgs): Promise<Actor> {
  const spawnedActor = await instantiatePrefabAsync(prefab.path, prefab.transform);
  if (!spawnedActor) {
    throw new Error(`Failed to spawn prefab actor: ${prefab.path}`);
  }
  return spawnedActor;
}

export async function placePrefabs(args: {
  world: World;
  prefabs: PrefabArgs[];
}): Promise<Actor[]> {
  const actors: Actor[] = [];

  for (const prefabArg of args.prefabs) {
    const prefabActor = await spawnPrefab(prefabArg);

    if (prefabArg.miscInfo) {
      const { name, ...rest } = prefabArg.miscInfo;
      if (name) prefabActor.setName(name);
      Object.assign(prefabActor.editorData, rest);
    }

    actors.push(prefabActor);
  }

  args.world.addActors(...actors);
  return actors;
}
